/** List of feature flag keys */
export const FEATURE_FLAGS = {
  REGISTRATION_SECURITY_CHANGES: 'registration-security-changes-feature-enabled',
  CONTACT_US_EMAIL: 'cp-contact-us-email-feature-enabled',
  EXCEEDED_MAX_NUMBER_OF_POLICIES: 'exceeded-max-number-of-policies',
  CLAIMS_QUESTIONNAIRE: 'claims-questionnaire',
  CLAIMS_DOC_UPLOAD_POST_SUBMISSION: 'claims-doc-upload-post-submission'
}